module.exports = __webpack_public_path__ + "img/image.6efa87bd.webp";